<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    title="Table Settings"
  >
    <Row title="Realtime updates">
      <label class="custom-toggle" style="vertical-align: -7px;">
        <input type="checkbox" v-model="isReactive" />
        <span
          class="custom-toggle-slider rounded-circle"
          data-label-off="No"
          data-label-on="Yes"
        />
      </label>
    </Row>
    <Row title="Locked for inherited">
      <label class="custom-toggle">
        <input type="checkbox" v-model="lockedForInherited" />
        <span
          class="custom-toggle-slider rounded-circle"
          data-label-off="No"
          data-label-on="Yes"
        ></span>
      </label>
    </Row>
    <Row title="Form Design">
      <b-button
        variant="primary"
        size="sm"
        @click="showFormBuilderModal"
      >
        Edit
      </b-button>
    </Row>
    <Row v-if="gridId === 'pages'" title="Create table on page added">
      <label class="custom-toggle">
        <input type="checkbox" v-model="pagesTable_createTableOnAdded" />
        <span
          class="custom-toggle-slider rounded-circle"
          data-label-off="No"
          data-label-on="Yes"
        ></span>
      </label>
    </Row>
  </b-modal>
</template>


<script>
// service
import db from '@/services/db'
// components
import Row from './Row'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: [
    'gridId', 'options'
  ],
  components: {
    Row,
  },
  computed: {
    isReactive: {
      get() {
        if (typeof this.options.isReactive === 'undefined') return true
        return this.options.isReactive || false
      },
      set(value) {
        const data = {
          gridId: this.gridId,
          oName: 'isReactive',
          oValue: value,
        }

        db.dataGrid.options.saveOption(data)
      },
    },
    lockedForInherited: {
      get() {
        return this.options.lockedForInherited || false
      },
      set(value) {
        const data = {
          gridId: this.gridId,
          oName: 'lockedForInherited',
          oValue: value,
        }

        db.dataGrid.options.saveOption(data)
      },
    },
    pagesTable_createTableOnAdded: {
      get() {
        return this.options.pagesTable_createTableOnAdded || false
      },
      set(value) {
        const data = {
          gridId: this.gridId,
          oName: 'pagesTable_createTableOnAdded',
          oValue: value,
        }

        db.dataGrid.options.saveOption(data)
      },
    },
  },
  methods: {
    open () {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    showFormBuilderModal() {
      eventBus.$emit(
        'showDataGridEditFormDataModal',
        this.gridId,
        null,
        'template'
      )
    },
  },
}
</script>

<style lang="scss">
.dataGridSettings {
  &__row {
    min-height: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 7px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
